import { computed, observable } from 'mobx';
import { IAutomationStepActionFlow } from '../../../types/automation.types';
import { AutomationStepActionFileBase } from './automation-step-action-file-base';
import { IAutomationSidebarConfig } from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/automation-sidebar.types';
import FlowSideBar from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/FlowSideBar';
import FolderSelect from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/Components/FolderSelect';
import TemplateSelectSideBarFlow from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/TemplateSelectSideBarFlow';
import AutomationBlockActionFlow from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderCanvas/AutomationBlockElements/AutomationBlockActionFlow';
import { IFlowsBetaUserType } from '~/models/user.model';

export class AutomationStepActionFlow
    extends AutomationStepActionFileBase
    implements IAutomationStepActionFlow
{
    @observable type: 'flow';

    // Represents flow's metadata
    @computed
    get fileTemplate() {
        const {
            companyStore: { currCompany }
        } = this.rootStore;

        return currCompany?.getFlowTemplate(this.file_template_id);
    }

    // Represents flow's full data
    @computed
    get flowTemplate() {
        const {
            automationUiStore: { selectedStep },
            flowStore
        } = this.rootStore;

        return flowStore.flows[selectedStep.fileTemplateId];
    }

    getSideBarConfig(
        userType?: IFlowsBetaUserType,
        folderName: string = ''
    ): IAutomationSidebarConfig {
        return {
            initialScreen: (() => {
                if (this.file_template_id) {
                    return 'main';
                }
                if (userType.hasNewFlowExp) {
                    return 'selectFolder';
                }
                return 'selectFile';
            })(),
            main: {
                headerProps: { title: 'Action' },
                component: FlowSideBar,
                parent: null
            },
            ...super.emailSideBarConfig,
            selectFolder: {
                headerProps: { title: 'Smart file templates' },
                component: FolderSelect,
                parent: 'main'
            },
            selectFile: {
                headerProps: {
                    title: userType.hasNewFlowExp
                        ? folderName
                        : 'Smart file template'
                },
                component: TemplateSelectSideBarFlow,
                parent: userType.hasNewFlowExp ? 'selectFolder' : 'main'
            }
        };
    }

    get AutomationBlockAction() {
        return AutomationBlockActionFlow;
    }
}
